const emailIsValid = (email: string): boolean => {
  return /.+@.+\..+/.test(email)
}

export default emailIsValid
